<template>
  <a-spin :spinning="loading">
    <div>
      <h3>Đăng đăng nhập bằng tài khoản Microsoft</h3>
      <p>Vui lòng bấm vào nút "Allow" để cho phép mở cửa sổ đăng nhập!</p>
      <p>
        Nếu không thấy nút "Allow" hoặc cửa sổ đăng nhập vui lòng bấm vào nút
        "Login" dưới đây!
      </p>
      <a-button type="primary" @click="openDialog()">Login</a-button>
    </div>
  </a-spin>
</template>
<script>
import { mapActions } from "vuex";
const { VUE_APP_SSO_URL, VUE_APP_AUTH_TOKEN_NAME } = process.env;

const callbackUrl = window.location.origin + "/callback.html";

const url = VUE_APP_SSO_URL + "go?r=" + callbackUrl;

export default {
  data() {
    return {
      dialog: undefined,
      timeRefresh: undefined,
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      loginAuth: "auth/login",
      initAuth: "auth/init",
    }),
    openDialog() {
      const vm = this;

      Office.onReady().then(() => {
        Office.context.ui.displayDialogAsync(
          window.location.origin + "/auth-start.html",
          {
            height: 50,
            width: 60,
            displayInIframe: false, // Set thành true sẽ dẫn đến lỗi
          },
          (asyncResult) => {
            // console.log("asyncResult", asyncResult);
            vm.dialog = asyncResult.value;
            // vm.dialog.addEventHandler(
            //   Office.EventType.DialogMessageReceived,
            //   vm.processMessage
            // );

            vm.loading = true;
            vm.timeRefresh = setTimeout(() => {
              vm.getToken();
            }, 800);
          }
        );
      });
    },

    getToken() {
      const vm = this;
      const token = localStorage.getItem(VUE_APP_AUTH_TOKEN_NAME);
      if (token) {
        clearTimeout(vm.timeRefresh);
        vm.initAuth();
        vm.loading = false;
        const path = "/form";
        vm.$router.push(path).catch((error) => {
          if (error.name != "NavigationDuplicated") {
            throw error;
          }
        });
      } else {
        vm.timeRefresh = setTimeout(() => {
          vm.getToken();
        }, 800);
      }
    },

    // processMessage(arg) {
    //   // var messageFromDialog = JSON.parse(arg.message);
    //   console.log("Đã nhận được tn: ", arg);
    //   if (arg.message) {
    //     localStorage.setItem(VUE_APP_AUTH_TOKEN_NAME, arg.message);
    //     this.loginAuth(arg.message);
    //   }
    //   this.dialog.close();

    //   const path = "/form";
    //   this.$router.push(path).catch((error) => {
    //     if (error.name != "NavigationDuplicated") {
    //       throw error;
    //     }
    //   });
    // },
  },
  created() {
    this.openDialog();
  },
};
</script>
